import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsetComponent } from './fieldset.component';
import { TextInputModule } from '../text-input/text-input.module';
import { SelectModule } from '../select/select.module';
import { BannerModule } from '../banner/banner.module';
import { InfoModule } from '../info/info.module';
import { ModalOpenerModule } from '../modal-opener/modal-opener.module';
import { CheckboxGroupModule } from '../checkbox-group/checkbox-group.module';
import { ReviewModule } from '../review/review.module';



@NgModule({
  declarations: [FieldsetComponent],
  imports: [
    CommonModule,
    TextInputModule,
    SelectModule,
    BannerModule,
    InfoModule,
    ModalOpenerModule,
    CheckboxGroupModule,
    ReviewModule
  ],
  exports: [FieldsetComponent]
})
export class FieldsetModule { }
